<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>资产订单</span>
          </div>
          <div class="form-container">
            <el-form :model="assetInventoryInInfo" label-width="100px">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="选择仓库">
                    <el-select 
                      v-model="assetInventoryInInfo.shId" 
                      placeholder="请选择仓库"
                      style="width:100%"
                    >
                      <el-option 
                        v-for="item in assetInventoryInInfo.shopHouses"
                        :key="item.shId"
                        :label="item.shName"
                        :value="item.shId"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="盘点日期">
                    <el-date-picker
                      v-model="assetInventoryInInfo.invTime"
                      type="datetime"
                      placeholder="选择日期时间"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      style="width:100%"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="盘点说明">
                    <el-input
                      v-model="assetInventoryInInfo.remark"
                      type="textarea"
                      :rows="3"
                      placeholder="请输入盘点说明"
                      maxlength="250"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row >
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>盘点商品</span>
            <el-button 
              type="primary" 
              size="small" 
              style="float:right"
              @click="_openChooseProductModal"
            >
              <i class="el-icon-plus"></i>选择商品
            </el-button>
          </div>
          <table class="custom-table">
            <thead>
              <tr>
                <th>编号</th>
                <th>名称</th>
                <th>规格</th>
                <th>单价</th>
                <th>账面数量</th>
                <th>盘点数量</th>
                <th>将过期</th>
                <th>耗损</th>
                <th>盘盈</th>
                <th>盘亏</th>
                <th>盘盈金额</th>
                <th>盘亏金额</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in assetInventoryInInfo.inoutOrderProducts" :key="index">
                <td>{{ item.productId }}</td>
                <td>{{ item.prodName }}</td>
                <td>{{ item.defaultSpecValue ? item.defaultSpecValue.specName : '' }}</td>
                <td>{{ item.defaultSpecValue ? item.defaultSpecValue.price : '' }}</td>
                <td>{{ item.quantity }}</td>
                <td>
                  <input
                    v-model.number="item.invQuantity"
                    type="number"
                    class="custom-input"
                    @blur="_computeData(item)"
                  />
                </td>
                <td>
                  <input
                    v-model.number="item.willExpire"
                    type="number"
                    class="custom-input"
                    @blur="_computeData(item)"
                  />
                </td>
                <td>
                  <input
                    v-model.number="item.attrition"
                    type="number"
                    class="custom-input"
                    @blur="_computeData(item)"
                  />
                </td>
                <td>{{ item.invProfit }}</td>
                <td>{{ item.invLoss }}</td>
                <td>{{ item.invProfitMoney }}</td>
                <td>{{ item.invLossMoney }}</td>
                <td>
                  <el-button
                    type="text"
                    size="small"
                    @click="_deleteProduct(item)"
                  >删除</el-button>
                </td>
              </tr>
            </tbody>
          </table>
        </el-card>
      </el-col>
    </el-row>

    <el-row style="margin-top:20px">
      <el-col :span="24">
        <div style="float:right">
          <el-button 
            type="warning" 
            style="margin-right:20px"
            @click="_goBack"
          >取消</el-button>
          <el-button 
            type="primary" 
            @click="_doAssetInventory"
          >提交</el-button>
        </div>
      </el-col>
    </el-row>

    <choose-product-and-spec ref="chooseProductModal" @chooseProductAndSpec="handleChooseProduct" />
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { saveAssetInventory, queryShopHouse } from '@/api/goods/assetInventoryApi'
import ChooseProductAndSpec from '@/components/goods/chooseProductAndSpec'

export default {
  components: {
    ChooseProductAndSpec
  },
  data() {
    return {
      assetInventoryInInfo: {
        shId: '',
        invTime: '',
        shopHouses: [],
        inoutOrderProducts: [],
        remark: '',
        shopId: getShopId()
      }
    }
  },
  created() {
    this._listShopHouses()
  },
  methods: {
    async _doAssetInventory() {
      // 验证仓库
      if (!this.assetInventoryInInfo.shId) {
        this.$message.warning('请选择仓库')
        return
      }
      
      // 验证商品
      const _inoutOrderProducts = this.assetInventoryInInfo.inoutOrderProducts
      if (_inoutOrderProducts.length < 1) {
        this.$message.warning('请选择商品')
        return
      }
      
      // 处理商品数据
      _inoutOrderProducts.forEach(item => {
        if (item.defaultSpecValue) {
          item.valueId = item.defaultSpecValue.valueId
          item.specName = item.defaultSpecValue.specName
        }
        // 确保数值字段存在
        item.invQuantity = item.invQuantity || 0
        item.willExpire = item.willExpire || 0
        item.attrition = item.attrition || 0
        item.invProfit = item.invProfit || 0
        item.invLoss = item.invLoss || 0
        item.invProfitMoney = item.invProfitMoney || 0
        item.invLossMoney = item.invLossMoney || 0
      })

      try {
        const response = await saveAssetInventory(this.assetInventoryInInfo)
        if (response.code === 0) {
          this.$message.success(response.msg || '提交成功')
          this._goBack()
        } else {
          this.$message.error(response.msg || '提交失败')
        }
      } catch (error) {
        console.error('提交资产盘点失败:', error)
        this.$message.error(error.message || error || '提交失败')
      }
    },
    _openChooseProductModal() {
      if (!this.assetInventoryInInfo.shId) {
        this.$message.warning('请先选择仓库')
        return
      }
      this.$refs.chooseProductModal.open({
        shId: this.assetInventoryInInfo.shId
      })
    },
    handleChooseProduct(products) {
      // products 是一个数组
      if (products && products.length > 0) {
        products.forEach(product => {
          product.invProfit = 0
          product.invLoss = 0
          product.invProfitMoney = 0
          product.invLossMoney = 0
          product.invQuantity = 0
          product.willExpire = 0
          product.attrition = 0
          product.quantity = product.defaultSpecValue ? product.defaultSpecValue.stock : 0
          // 设置price属性，用于_computeData计算（与原JS文件一致）
          product.price = product.defaultSpecValue ? product.defaultSpecValue.price : 0
          this.assetInventoryInInfo.inoutOrderProducts.push(product)
        })
      }
    },
    _goBack() {
      this.$router.go(-1)
    },
    _deleteProduct(product) {
      const index = this.assetInventoryInInfo.inoutOrderProducts.indexOf(product)
      if (index > -1) {
        this.assetInventoryInInfo.inoutOrderProducts.splice(index, 1)
      }
    },
    _listShopHouses() {
      queryShopHouse({
        page: 1,
        row: 100,
        shopId: this.assetInventoryInInfo.shopId
      }).then(response => {
        this.assetInventoryInInfo.shopHouses = response.data
      }).catch(error => {
        console.log('请求失败处理', error)
      })
    },
    _computeData(product) {
      const invQuantity = parseInt(product.invQuantity || 0)
      const quantity = parseInt(product.quantity || 0)
      // 优先使用product.price，如果没有则使用defaultSpecValue.price
      const price = parseFloat(product.price || (product.defaultSpecValue ? product.defaultSpecValue.price : 0) || 0)
      
      product.invProfit = invQuantity - quantity
      if (product.invProfit < 0) {
        product.invProfit = 0
      }
      product.invLoss = quantity - invQuantity
      if (product.invLoss < 0) {
        product.invLoss = 0
      }
      product.invProfitMoney = product.invProfit * price
      product.invLossMoney = product.invLoss * price
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped>
.form-container {
  padding: 20px;
}
.box-card {
  margin-bottom: 20px;
}

.custom-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #EBEEF5;
  font-size: 14px;
  color: #606266;
}

.custom-table thead {
  background-color: #F5F7FA;
}

.custom-table th {
  padding: 12px 0;
  text-align: center;
  border-bottom: 1px solid #EBEEF5;
  border-right: 1px solid #EBEEF5;
  font-weight: 500;
  color: #909399;
  font-size: 14px;
}

.custom-table th:last-child {
  border-right: none;
}

.custom-table tbody tr {
  border-bottom: 1px solid #EBEEF5;
}

.custom-table tbody tr:last-child {
  border-bottom: none;
}

.custom-table tbody tr:hover {
  background-color: #F5F7FA;
}

.custom-table td {
  padding: 12px 0;
  text-align: center;
  border-right: 1px solid #EBEEF5;
}

.custom-table td:last-child {
  border-right: none;
}

.custom-input {
  width: 100%;
  height: 32px;
  line-height: 32px;
  padding: 0 15px;
  box-sizing: border-box;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  font-size: 14px;
  color: #606266;
  background-color: #FFF;
  outline: none;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.custom-input:hover {
  border-color: #C0C4CC;
}

.custom-input:focus {
  border-color: #409EFF;
  outline: none;
}

.custom-input:disabled {
  background-color: #F5F7FA;
  border-color: #E4E7ED;
  color: #C0C4CC;
  cursor: not-allowed;
}
</style>